import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Products from '@/components/product/Products'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    children: [
      {
        name: 'Products',
        path: '/',
        component: Products
      },
      {
        name: 'Product',
        path: 'products/:id',
        component: () => import('@/components/product/Product'),
        props: true
      },
      {
        name: 'Favorites',
        path: 'favorites',
        component: () => import('@/components/product/Favorites'),
        props: true
      },
      {
        path: '/about',
        name: 'AboutUs',
        component: () => import('@/views/AboutUs')
      },
      {
        path: '/contact',
        name: 'ContactUs',
        component: () => import('@/views/ContactUs')
      },
      {
        path: '/welcome',
        name: 'Welcome',
        component: () => import('@/components/user/Welcome.vue')
      },
      {
        path: '/action',
        name: 'Action',
        component: () => import('@/components/user/Action.vue')
      },
      {
        path: '/verified',
        name: 'Verified',
        component: () => import('@/components/user/Verified.vue')
      },
      {
        path: '/message-sent',
        name: 'MessageSent',
        component: () => import('@/views/MessageSent.vue')
      },
      {
        path: '/email-sent',
        name: 'EmailSent',
        component: () => import('@/components/user/EmailSent.vue')
      }
    ]
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/admin/Dashboard.vue'),
    children: [
      {
        path: '/suppliers',
        name: 'Suppliers',
        component: () => import('@/components/admin/supplier/Suppliers.vue')
      },
      {
        path: '/my-products',
        name: 'MyProducts',
        component: () => import('@/components/admin/product/MyProducts.vue')
      },
      {
        name: 'SupplierProducts',
        path: 'suppliers/:id',
        component: () => import('@/components/admin/supplier/SupplierProducts'),
        props: true
      }
    ]
  },
  {
    path: '/sign-in',
    alias: '/login',
    name: 'SignIn',
    component: () => import('@/components/user/SignIn')
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('../components/user/ResetPassword.vue')
  },
  {
    path: '/set-new-password',
    name: 'SetNewPassword',
    component: () => import('../components/user/SetNewPassword.vue'),
    props: true
  },
  {
    path: '/sign-up',
    alias: '/register',
    name: 'SignUp',
    component: () => import('../components/user/sign_up/SignUpChoice.vue'),
    children: [
      {
        path: '/sign-up/supplier',
        name: 'SignUpSupplier',
        component: () => import('../components/user/sign_up/SignUpSupplier.vue')
      },
      {
        path: '/sign-up/customer',
        name: 'SignUpCustomer',
        component: () => import('../components/user/sign_up/SignUpCustomer.vue')
      }
    ]
  },
  {
    path: '/verify_account',
    name: 'VerifyAccount',
    component: () => import('@/components/supplier/VerifyAccount')
  },
  {
    path: '/spa',
    name: 'SPa',
    component: () => import('../views/admin/Spa')
  },
  {
    path: '/manager',
    name: 'Manager',
    component: () => import('../views/admin/Manager')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

export default router
